import { SendAdminCode, get_safeinfo } from "@/api/set";
import { iCSendSms } from "@/api/ic";
import Vue from "@/main";
import {getImageBase64Code} from '@/api/set.js'

let verificationCode = {
  // 向用户发送验证码
  async SendUserCode(mobile, code, uuid) {
    try {
      var data = {
        app_id: Vue.$store.getters.app_id,
        token: Vue.$store.getters.token,
        mobile,
        code,
        uuid
      };
      const res = await iCSendSms(data);
      if (res.code == 200) {
        Vue.$message.success(res.msg);
      } else {
        Vue.$message.error(res.msg);
      }
    } catch (error) {
      console.log(error);
    }
  },
  async getImage() {
    const res = await getImageBase64Code();
    if(res.code == 200){
      return res.data;
    }
  },

  // 管理员发送验证码
  async SendMyCode() {
    try {
      var data = { app_id: Vue.$store.getters.app_id };
      const res = await SendAdminCode(data);
      if (res.code == 200) {
        Vue.$message.success(res.msg);
      } else {
        Vue.$message.error(res.msg);
      }
    } catch (error) {
      console.log(error);
    }
  },

  // 安全設置详情
  async get_detail(name) {
    try {
      var data = { app_id: Vue.$store.getters.app_id };
      const res = await get_safeinfo(data);
      if (res.code == 200) {
        let status = res.data[name] == 0 ? false : true;
        return status;
      }
    } catch (error) {
      console.log(error);
    }
  }
};
export default verificationCode;
